'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOverlayTransition = undefined;

var _styledComponents = require('styled-components');

var _times = require('HubStyleTokens/times');

var getOverlayTransition = exports.getOverlayTransition = function getOverlayTransition(dialogTransitionTime) {
  return (0, _styledComponents.css)(['.private-modal-dialog--overlay{transition-property:', ';transition-delay:', 'ms;transition-duration:', ';background-color:', ';}'], function (_ref) {
    var transitioning = _ref.transitioning;
    return transitioning ? 'background-color' : 'none';
  }, function (_ref2) {
    var open = _ref2.open;
    return open ? 0 : dialogTransitionTime;
  }, _times.MODAL_BACKGROUND_TRANSITION_TIMING, function (_ref3) {
    var open = _ref3.open;
    return 'rgba(45, 62, 80, ' + (open ? '0.79' : '0') + ')';
  });
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/dialog/internal/overlayTransitionMixin.js
// module id = 552
// module chunks = 177